import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ras-reasons-to-love',
	templateUrl: './reasons-to-love.component.html',
	styleUrls: ['./reasons-to-love.component.sass']
})
export class ReasonsToLoveComponent implements OnInit {

	public show_more_reasons = true

	constructor() { }

	ngOnInit() {
	}

}
